export enum AutoSaveState {
  NotStarted,
  InProgress,
  Completed,
}